'use strict';

var React = require('react');

var SvgShipmentFilledMajor = function SvgShipmentFilledMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M4.75 5a.75.75 0 0 0 0 1.5h3.5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 0 0 1.5h3a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 0 0 1.5h.458a2.5 2.5 0 1 0 4.78.75h3.024a2.5 2.5 0 1 0 4.955-.153 1.75 1.75 0 0 0 1.033-1.597v-1.22a1.75 1.75 0 0 0-1.326-1.697l-1.682-.42a.283.283 0 0 1-.195-.195 20.21 20.21 0 0 0-.344-.979l-.026-.07c-.41-1.1-1.448-1.919-2.686-1.919h-6.991Zm1.75 7.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm8 2a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};
SvgShipmentFilledMajor.displayName = "ShipmentFilledMajor";

exports.SvgShipmentFilledMajor = SvgShipmentFilledMajor;
